import type { ExtensionConfig } from "@repo/shared-types";

import { ExtensionConfigSection } from "./ExtensionConfig";
import { TemplateSelector } from "./TemplateSelector";

type V4AdvancedConfigProps = {
	extensions: ExtensionConfig[];
	onExtensionsChange: (extensions: ExtensionConfig[]) => void;
};

export function V4AdvancedConfig({ extensions, onExtensionsChange }: V4AdvancedConfigProps) {
	const handleTemplateSelect = (template: {
		extensions: ExtensionConfig[];
	}) => {
		onExtensionsChange(template.extensions);
	};

	return (
		<div className="space-y-8">
			{/* Template Selector */}
			<div>
				<h3 className="text-lg font-semibold text-pastel-black mb-3">Quick Setup Templates</h3>
				<p className="text-sm text-pastel-gray mb-4">
					Choose a preset configuration or customize individual settings below.
				</p>
				<TemplateSelector onTemplateSelect={handleTemplateSelect} />
			</div>

			{/* Extensions */}
			<div>
				<h3 className="text-lg font-semibold text-pastel-black mb-3">Extensions</h3>
				<p className="text-sm text-pastel-gray mb-4">
					Add additional features to your token launch. Each extension can be customized with
					specific parameters.
				</p>
				<ExtensionConfigSection extensions={extensions} onExtensionsChange={onExtensionsChange} />
			</div>
		</div>
	);
}
